import { Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { HomePage } from "@/pages/Home";
import { MedicamentosPage } from "@/pages/Medicamentos";
import { CaixasPage } from "@/pages/Caixas";
import { DevolucoesPage } from "@/pages/Devolucoes";
import { DispensacoesPage } from "@/pages/Dispensacoes";
import { EntradaEstoquePage } from "@/pages/EntradaEstoque";
import { LivroPage } from "@/pages/Livro";
import { NotasFiscaisPage } from "@/pages/NotasFiscais";
import { PacientesPage } from "@/pages/Pacientes";
import { RelatoriosPage } from "@/pages/Relatorios";
import { RequisicoesPage } from "@/pages/Requisicoes";
import { AuditRecipientsPage } from "@/pages/admin/AuditRecipients";
import { ComposicaoKitsPage } from "@/pages/admin/Composicao";
import { LocaisPage } from "@/pages/admin/Locais";
import { UnidadesPage } from "@/pages/admin/Unidades";

export default function App() {
  return (
    <ProtectedRoute>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/medicamentos" element={<MedicamentosPage />} />
          <Route path="/pacientes" element={<PacientesPage />} />
          <Route path="/nfs" element={<NotasFiscaisPage />} />
          <Route path="/requisicoes" element={<RequisicoesPage />} />
          <Route path="/dispensacoes" element={<DispensacoesPage />} />
          <Route path="/devolucoes" element={<DevolucoesPage />} />
          <Route path="/entrada-estoque" element={<EntradaEstoquePage />} />
          <Route path="/caixas" element={<CaixasPage />} />
          <Route path="/livro" element={<LivroPage />} />
          <Route path="/relatorios" element={<RelatoriosPage />} />
          <Route path="/admin/composicao-kits" element={<ComposicaoKitsPage />} />
          <Route path="/admin/unidades" element={<UnidadesPage />} />
          <Route path="/admin/locais" element={<LocaisPage />} />
          <Route path="/admin/audit-recipients" element={<AuditRecipientsPage />} />
          <Route path="*" element={<div className="text-ink-muted">Página não encontrada.</div>} />
        </Route>
      </Routes>
    </ProtectedRoute>
  );
}
